import { render, staticRenderFns } from "./PatrolUnits.vue?vue&type=template&id=55495878&"
import script from "./PatrolUnits.vue?vue&type=script&lang=js&"
export * from "./PatrolUnits.vue?vue&type=script&lang=js&"
import style0 from "./PatrolUnits.vue?vue&type=style&index=0&id=55495878&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports